import { DateTime } from 'luxon';
import { AbstractViewModel } from '../../../abstract.view.model';
import { CardPointsToExpireApiModel } from '../../../api-model/account-items/card/card-points-to-expire.api.model';

export class CardPointsToExpireViewModel extends AbstractViewModel<CardPointsToExpireApiModel> {
  public expiryDate: DateTime;
  public points: number;

  constructor(protected apiModel: CardPointsToExpireApiModel = new CardPointsToExpireApiModel()) {
    super(apiModel);
    this.fromApiModel();
  }

  protected fromApiModel(): void {
    this.expiryDate = this.apiModel.expiryDate ? DateTime.fromISO(this.apiModel.expiryDate) : null;
    this.points = this.apiModel.points;
  }

  toApiModel(): CardPointsToExpireApiModel {
    return this.apiModel;
  }
}
